import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useState, useCallback, useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TrialSignupModal from "./components/TrialSignupModal";
import CerebrumWidget from "./components/CerebrumWidget";
import HomePage from "./pages/HomePage";
import SpacePage from "./pages/SpacePage";
import RogueHub from "./pages/RogueHub";
import ModulePage from "./pages/ModulePage";
import RoguePricing from "./pages/RoguePricing";
import CerebrumPage from "./pages/CerebrumPage";
import CloudPage from "./pages/CloudPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import LegalPage from "./pages/LegalPage";
import CaseStudy from "./pages/CaseStudy";
import ComingSoonPage from "./pages/ComingSoonPage";
import RendersPage from "./pages/RendersPage";
import NexusHub from "./pages/NexusHub";
import NexusHardwarePage from "./pages/NexusHardwarePage";
import KinlyPage from "./pages/KinlyPage";
import { CurrencyProvider } from "./context/CurrencyContext";
import NotFound from "./pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppShell() {
  const [trialOpen, setTrialOpen] = useState(false);
  const openTrial = useCallback(() => setTrialOpen(true), []);
  const closeTrial = useCallback(() => setTrialOpen(false), []);

  return (
    <div className="grain-overlay min-h-screen flex flex-col">
      <ScrollToTop />
      <Navbar onTrialClick={openTrial} />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage onTrialClick={openTrial} />} />
          <Route path="/space" element={<SpacePage onTrialClick={openTrial} />} />
          <Route path="/space/rogue" element={<RogueHub onTrialClick={openTrial} />} />
          <Route path="/space/rogue/pricing" element={<RoguePricing onTrialClick={openTrial} />} />
          <Route path="/space/rogue/case-study" element={<CaseStudy onTrialClick={openTrial} />} />
          <Route path="/space/rogue/:module" element={<ModulePage onTrialClick={openTrial} />} />
          <Route path="/space/kinly" element={<KinlyPage />} />
          <Route path="/space/security" element={<ComingSoonPage name="Geminii Security" />} />
          <Route path="/space/construction" element={<ComingSoonPage name="Geminii Construction" />} />
          <Route path="/cerebrum" element={<CerebrumPage onTrialClick={openTrial} />} />
          <Route path="/nexus" element={<NexusHub onTrialClick={openTrial} />} />
          <Route path="/nexus/hardware" element={<NexusHardwarePage onTrialClick={openTrial} />} />
          <Route path="/cloud" element={<CloudPage />} />
          <Route path="/pricing" element={<Navigate to="/space/rogue/pricing" replace />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/legal/:page" element={<LegalPage />} />
          <Route path="/renders" element={<RendersPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <TrialSignupModal open={trialOpen} onClose={closeTrial} />
      <CerebrumWidget />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CurrencyProvider>
        <AppShell />
      </CurrencyProvider>
    </BrowserRouter>
  );
}

export default App;
